<div class="container" outsideClick (outsideClick)="close()">
  <div class="input" (click)="open()" [class.active]="show">
    {{ showHour() }}
    <div inlineSVG="/assets/icons/time-icon.svg" [class.active]="show"></div>
  </div>
  <div class="picker" *ngIf="show" [ngStyle]="style">
    <div class="close-calendar" (click)="close()"></div>
    <div class="header">24 HOURS</div>
    <div class="content">
      <div
        class="hourcell"
        *ngFor="let hour of createArray()"
        (click)="onHourSelecting(hour)"
        [class.chosen]="hourChosen === hour"
        (click)="onHourSelecting(hour)"
      >
        {{ hour }}
      </div>
    </div>
    <div class="apply-btn" (click)="onApply(); $event.stopPropagation()">
      Apply
    </div>
  </div>
</div>
